// extracted by mini-css-extract-plugin
export default {"text":"TextWithLinks_text__NJk+u","link":"TextWithLinks_link__0xe8w"};